/**
 * @file Workslip form child component
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { FormChildBase } from '../../base/form-child/form-child.base';
import { AlertsService } from '../../core/alerts.service';
import { WorkSlipsService } from '../workslips.service';
import { ResourceService } from '../../resource.service';
var WorkSlipFormChildComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WorkSlipFormChildComponent, _super);
    /**
    * Creates an instance of WorkSlipFormChildComponent.
    * @param {WorkSlipsService} workSlipsService
    * @param {TranslateService} translateService
    * @param {AlertsService} alertsService
    * @memberof WorkSlipFormChildComponent
    */
    function WorkSlipFormChildComponent(workSlipsService, translateService, alertsService, resourceService) {
        return _super.call(this, workSlipsService, translateService, alertsService, resourceService) || this;
    }
    return WorkSlipFormChildComponent;
}(FormChildBase));
export { WorkSlipFormChildComponent };
